SET_MULTIPLE_GUIDE_DAYS